import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TopRevenuePartners = () => {
  const topPartners = [
  {
    id: 1,
    name: "Golden Spoon Restaurant",
    vertical: "Food Delivery",
    avatar: "https://images.unsplash.com/photo-1672870634122-6ea7b16d2bb4",
    avatarAlt: "Modern restaurant interior with golden lighting and elegant table settings",
    revenue: 89420,
    orders: 2340,
    commission: 11290,
    growth: "+23.5%",
    rating: 4.8,
    status: "active"
  },
  {
    id: 2,
    name: "Elite Home Services",
    vertical: "Home Services",
    avatar: "https://images.unsplash.com/photo-1660330589693-99889d60181e",
    avatarAlt: "Professional home service technician in uniform working on electrical installation",
    revenue: 76890,
    orders: 1890,
    commission: 11150,
    growth: "+18.2%",
    rating: 4.9,
    status: "active"
  },
  {
    id: 3,
    name: "Prime Properties Ltd",
    vertical: "Property",
    avatar: "https://images.unsplash.com/photo-1659290129792-e3ba3fc29c51",
    avatarAlt: "Luxury modern house exterior with glass windows and landscaped garden",
    revenue: 124560,
    orders: 340,
    commission: 12980,
    growth: "+31.7%",
    rating: 4.7,
    status: "active"
  },
  {
    id: 4,
    name: "Adventure Tours Co",
    vertical: "Tours & Travel",
    avatar: "https://images.unsplash.com/photo-1589534657441-3fb0bb484a5d",
    avatarAlt: "Scenic mountain landscape with hiking trail and adventure tour group in distance",
    revenue: 45670,
    orders: 890,
    commission: 9140,
    growth: "+12.8%",
    rating: 4.6,
    status: "active"
  },
  {
    id: 5,
    name: "Urban Eats Chain",
    vertical: "Food Delivery",
    avatar: "https://images.unsplash.com/photo-1682851218650-6f417f9130ff",
    avatarAlt: "Modern urban restaurant kitchen with chefs preparing gourmet food dishes",
    revenue: 67890,
    orders: 1560,
    commission: 8540,
    growth: "+15.4%",
    rating: 4.5,
    status: "active"
  }];


  const getVerticalColor = (vertical) => {
    const colors = {
      'Food Delivery': 'bg-blue-100 text-blue-800',
      'Home Services': 'bg-green-100 text-green-800',
      'Property': 'bg-orange-100 text-orange-800',
      'Tours & Travel': 'bg-red-100 text-red-800'
    };
    return colors?.[vertical] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 elevation-1">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Top Revenue Partners</h3>
          <p className="text-sm text-muted-foreground">Highest earning partners this month</p>
        </div>
        <Icon name="Crown" size={20} className="text-warning" />
      </div>
      <div className="space-y-4">
        {topPartners?.map((partner, index) =>
        <div key={partner?.id} className="flex items-center space-x-4 p-4 bg-muted/30 rounded-lg hover:bg-muted/50 transition-hover">
            <div className="flex items-center space-x-3 flex-1">
              <div className="relative">
                <div className="w-12 h-12 rounded-lg overflow-hidden">
                  <Image
                  src={partner?.avatar}
                  alt={partner?.avatarAlt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="absolute -top-1 -left-1 w-5 h-5 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-xs font-bold">
                  {index + 1}
                </div>
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2 mb-1">
                  <h4 className="text-sm font-medium text-foreground truncate">{partner?.name}</h4>
                  <div className="flex items-center space-x-1">
                    <Icon name="Star" size={12} className="text-warning fill-current" />
                    <span className="text-xs text-muted-foreground">{partner?.rating}</span>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getVerticalColor(partner?.vertical)}`}>
                    {partner?.vertical}
                  </span>
                  <span className="text-xs text-success font-medium">{partner?.growth}</span>
                </div>
              </div>
            </div>

            <div className="text-right space-y-1">
              <p className="text-sm font-semibold text-foreground">${partner?.revenue?.toLocaleString()}</p>
              <p className="text-xs text-muted-foreground">{partner?.orders} orders</p>
              <p className="text-xs text-accent font-medium">${partner?.commission?.toLocaleString()} comm.</p>
            </div>
          </div>
        )}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Total from top 5 partners</span>
          <div className="text-right">
            <p className="font-semibold text-foreground">${topPartners?.reduce((sum, p) => sum + p?.revenue, 0)?.toLocaleString()}</p>
            <p className="text-xs text-muted-foreground">
              {(topPartners?.reduce((sum, p) => sum + p?.revenue, 0) / 2847392 * 100)?.toFixed(1)}% of total revenue
            </p>
          </div>
        </div>
      </div>
    </div>);

};

export default TopRevenuePartners;